import React from "react";

import SolutionSlide from "../../components/SolutionSlide";

import CaseFilterIdentity from "../../components/CaseFilterIdentity";

import useFilterFromLocation from "../../hooks/useFilterFromLocation";

import {
	getCaseVideo,
} from "../../data/cases/getCaseVideoHelper";

import {
	getCaseDisplayFilter,
} from "../../data/cases/caseFilterPresentation";

import styles from "../Solutions.module.css";

const SolutionsSlider = ({
	cases,
	preloaded,
	isPortraitMode,
	isOfflineMode,
	debugComplication,
	isEnabled,
	activeVideo,
	curScale,
	windowWidth,
	activeSlide,
	cKey,
	onscroll,

	sliderWrapperRef,
	sliderRef,
	titleContainerRef,
	centerTitleIndexRef,
	centerTitleNameRef,
	blackOverlayRef,

	handleSlideClick,
	nextLiveSlide,
}) => {
	const caseItems =
		cases?.[0] ?? [];

	const renderVersion =
		cases?.[1];

	const caseFilter =
		useFilterFromLocation();

	const centerCase =
		caseItems?.[
			nextLiveSlide
		];

	const centerDisplayFilter =
		getCaseDisplayFilter(
			centerCase,
			caseFilter,
		);

	const centerDisplayFilterIsPrimary =
		centerDisplayFilter?.value ===
			"work" ||
		centerDisplayFilter?.value ===
			"solution";

	return (
		<div
			className="slider-wrapper"
			ref={
				sliderWrapperRef
			}
		>
			{isPortraitMode ? null : (
				<div
					className={`grid ${styles.gridMuted}`}
				>
					<div className="grid-line _4" />

					<div className="grid-line _3" />

					<div className="grid-line _2" />

					<div className="grid-line _1" />

					<div className="grid-line _0" />
				</div>
			)}

			<div
				className="slider"
				ref={
					sliderRef
				}
				style={{
					opacity:
						preloaded
							? 1
							: 0,
				}}
			>
				{caseItems.map(
					(
						solution,
						i,
					) => {
						const slideKey =
							"slide_" +
							solution?.shorthand +
							renderVersion +
							cKey;

						return (
							<SolutionSlide
								debugComplication={
									debugComplication
								}
								preloaded={
									preloaded
								}
								type={
									solution?.type
								}
								tags={
									solution?.tags
								}
								caseFilter={
									caseFilter
								}
								isEnabled={
									isEnabled
								}
								activeVideo={
									activeVideo
								}
								curScale={
									curScale
								}
								isSmallScreen={
									windowWidth <
									768
								}
								activeSlide={
									activeSlide
								}
								key={
									slideKey
								}
								cKey={
									slideKey
								}
								index={
									i
								}
								solution={
									solution
								}
								title={
									solution?.name ||
									"N/A"
								}
								isPortraitMode={
									isPortraitMode
								}
								preview={
									isPortraitMode
										? null
										: getCaseVideo(
												solution.shorthand,
												"landscape-pr",

												isOfflineMode
													? "2160p"
													: "720p",
										  )
								}
								main={
									isPortraitMode
										? solution?.type ===
										  "work"
											? getCaseVideo(
													solution.shorthand,
													"portrait-pr",

													isOfflineMode
														? "2160p"
														: "1080p",
											  )
											: getCaseVideo(
													solution.shorthand,
													"portrait",

													isOfflineMode
														? "2160p"
														: "1080p",
											  )
										: getCaseVideo(
												solution.shorthand,
												"landscape",

												isOfflineMode
													? "2160p"
													: "1440p",
										  )
								}
								poster={
									isPortraitMode
										? solution?.[
												"poster-portrait-900p"
										  ] ?? ""
										: solution?.[
												"poster-landscape-1600p"
										  ] ?? ""
								}
								onclick={() => {
									handleSlideClick(
										i,
									);
								}}
								onscroll={
									onscroll
								}
							/>
						);
					},
				)}
			</div>

			<div
				className={`sol-title-wrapper ${styles.hiddenTitle}`}
				ref={
					titleContainerRef
				}
			>
				<div
					className="sol-title-slider-item"
					key="title_center"
				>
					<div
						className="sol-index prevent-select"
						ref={
							centerTitleIndexRef
						}
					>
						{nextLiveSlide +
							1 <
						10
							? "0" +
							  (nextLiveSlide +
									1)
							: nextLiveSlide +
							  1}
					</div>

					<div
						className="sol-main-el prevent-select"
						ref={
							centerTitleNameRef
						}
					>
						{
							centerCase?.name
						}
					</div>
				</div>

				{centerCase ? (
					<div
						className={`slider-tag-new${
							centerDisplayFilterIsPrimary
								? ` ${centerDisplayFilter.value}`
								: ""
						}`}
					>
						<CaseFilterIdentity
							filter={
								centerDisplayFilter.value
							}
							slide
						/>

						<div className="slider-tag-new-txt">
							{
								centerDisplayFilter.label
							}
						</div>
					</div>
				) : null}
			</div>

			<div
				className={`black-overlay ${styles.hiddenOverlay}`}
				ref={
					blackOverlayRef
				}
			/>
		</div>
	);
};

export default React.memo(
	SolutionsSlider,
);